// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"32cc75483a2bfff75896","883":"df267964a6abdb2d6926"}[chunkId] + ".js";
};